import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { RegisterData } from './register-data';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FormError, GeneralError } from './response-with-success.interceptor';

interface RegisteredUserDTO {
    username: string;
    email: string;
    is_active: false;
}

@Injectable({
    providedIn: 'root'
})
export class RegisterService {
    private readonly http: HttpClient = inject(HttpClient);

    readonly URL: string = '/abaqus/rest_api/webapp/auth/register_user_ask/';

    register$(data: RegisterData): Observable<void> {
        return this.http.post<RegisteredUserDTO>(this.URL, data.createRequestBody()).pipe(
            map(() => void (0)),
            catchError((error: HttpErrorResponse) => this.toRegisterError(error)),
        );
    }

    private toRegisterError(error: HttpErrorResponse): Observable<never> {
        if (error.status === 400) {
            return throwError(() => new FormError('', this.flatErrorMessages(error.error)));
        }
        if (error.status === 409) {
            return throwError(() => new GeneralError(error.error?.detail ?? ''));
        }
        return throwError(() => error);
    }

    private flatErrorMessages(body: { [key: string]: string[] }): { [key: string]: string } {
        const formErrors: { [key: string]: string } = {};
        for (const field of Object.keys(body)) {
            formErrors[field] = body[field].join(' ');
        }
        return formErrors;
    }
}

